import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Auth from "./components/Auth";
import Movies from "./components/Movies";
import Seats from "./components/Seats";
import Payment from "./components/Payment";
import Layout from "./components/Layout";
import ReservationCheck from "./components/ReservationCheck";
import DatadogDemo from "./components/DatadogDemo";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Auth />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/movies/:movieId/seats" element={<Seats />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/check-reservations" element={<ReservationCheck />} />
          <Route path="/datadog-demo" element={<DatadogDemo />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
